// Dynamically set base URL based on current website's origin
export const getAppBaseUrl = () => {
  console.log(window.location.origin);

  if (
    window.location.origin.includes("dev") ||
    window.location.origin.includes("localhost")
  ) {
    return "https://dev.numbers.ag/";
  }

  // Use the current origin and append the API path
  return "https://app.numbers.ag/";
};
